import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin, { ThirdPartyDraggable } from "@fullcalendar/interaction"; // needed for dayClick
import styled from "styled-components";
import "./main.scss";
import dayjs from 'dayjs';

export default class CalendarMonth extends React.Component {
  constructor(props) {
    super(props);
    this.calendarRef = React.createRef();

    this.state = {
      selectedDates: [],
      showInfo: false,
      info: {},
      events: props.events,
      justSelected: false,
      eventId: 0
    };
    this.timer = null

    this.handleAddDate = props.handleAddDate;
    this.handleRemoveDate = props.handleRemoveDate;

  }




  static getDerivedStateFromProps(props, state) {
    if (props.selectedDates !== state.selectedDates) {
      return { selectedDates: props.selectedDates }
    }
    return null;

  }

  componentDidUpdate() {

  }


  hideToolTip = () => {
    this.setState({
      showInfo: false,
      info: {},
    });
  }
  handleLeaveEvent = ({ event }) => {
    clearTimeout(this.timer)
    this.setState({
      showInfo: false,
      info: {},
    });
  };

  handleMouseEnter = ({ event, jsEvent }) => {
    if (event.groupId == "temp") {

      return;
    }
    this.eventClick(event, jsEvent);
  };

  handleEventClick = (clickedEvent) => {
    let { event, jsEvent } = clickedEvent;
    if (event.groupId == "temp") {
      this.handleRemoveDate(event);
      event.remove();
      return;
    }
    this.eventClick(event, jsEvent);
  };

  handleDateClick = (clickedDate) => {
    if (this.state.justSelected) {
      this.setState({justSelected: false});
      return;
    }
    let calendarApi = this.calendarRef.current.getApi();

    let endClickedDate = dayjs(clickedDate.date).add(1, "day");
    let clicked = dayjs(clickedDate.date);
    let listEvents = calendarApi.getEvents();
    let eventsCalendar = listEvents.filter((event) => {
      if (event.groupId !== "temp") {
        return false;
      }
      // Check if clicked date is adjacent to start, adjacent to end, or within the event
      let diffToStart = clicked.diff(dayjs(event.start), 'day');
      let diffToEnd = clicked.diff(dayjs(event.end), 'day');
      return diffToStart >= -1 && diffToEnd <= 0;
    });
    if (eventsCalendar.length === 1) {
      let event = eventsCalendar[0];
      let eventStart = dayjs(event.start);
      let eventEnd = dayjs(event.end);

      if (eventStart.isSame(clicked) && eventEnd.isSame(endClickedDate)) {
        this.handleRemoveDate(event);
        event.remove();
        return;
      }
      if (eventStart.isSame(endClickedDate)) {
        this.createBackgroundEvent(clicked.toDate(), eventEnd.toDate());
        this.handleRemoveDate(event);
        event.remove()
        return;
      }
      if (eventEnd.isSame(clicked)) {
        this.createBackgroundEvent(eventStart.toDate(), endClickedDate.toDate());
        this.handleRemoveDate(event);
        event.remove()
        return;
      }

      event.remove()
      this.createBackgroundEvent(eventStart.toDate(), clicked.toDate());
      this.createBackgroundEvent(endClickedDate.toDate(), eventEnd.toDate());
      this.handleRemoveDate(event);

    } else if (eventsCalendar.length > 1) {
      // Clicked date bridges multiple events — merge them all
      let mergedStart = clicked;
      let mergedEnd = endClickedDate;
      eventsCalendar.forEach((event) => {
        let eventStart = dayjs(event.start);
        let eventEnd = dayjs(event.end);
        if (eventStart.isBefore(mergedStart)) mergedStart = eventStart;
        if (eventEnd.isAfter(mergedEnd)) mergedEnd = eventEnd;
        this.handleRemoveDate(event);
        event.remove();
      });
      this.createBackgroundEvent(mergedStart.toDate(), mergedEnd.toDate());
    } else {
      this.createBackgroundEvent(clicked.toDate(), endClickedDate.toDate());
    }

  };

  eventClick = (event, jsEvent) => {
    const { dayTypeName, comment } = event.extendedProps;
    clearTimeout(this.timer)
    this.setState({
      showInfo: true,
      info: {
        pageX: jsEvent.clientX,
        pageY: jsEvent.clientY,
        title: dayTypeName,
        comment: comment,
        color: event.textColor,
      },
    });
    this.timer = setTimeout(() => {
      this.setState({
        showInfo: false,
        info: {},
      });
    }, 3000)
  }

  handleDatesSelected = (datesSelected) => {

    //if(dayjs(datesSelected.start).diff(dayjs(datesSelected.end),'day') == -1) {
    //  this.handleDateClick({date: datesSelected.start});
    //  return false;
    //}
    this.setState({justSelected:true});

    let calendarApi = this.calendarRef.current.getApi();
    let events = calendarApi.getEvents().filter((event) => { return event.groupId == "temp" });
    if (this.checkIfDateOverlapsAnother(datesSelected, events)) {

      return false;
    }

    if (this.checkIfDatesInBetweenEvents(datesSelected, events)) {
      return false;
    }

    if (this.checkIfDatesSelectedBeforeEvent(datesSelected, events)) {
      return false;
    }

    if (this.checkIfDatesSelectedNextEvent(datesSelected, events)) {
      return false;
    }

    this.createBackgroundEvent(datesSelected.start, datesSelected.end);
    return false;

  };

  evauluateDates = (datesSelected, event) => {
    let startSelected = dayjs(datesSelected.start)
    let endSelected = dayjs(datesSelected.end)
    let eventStart = dayjs(event.start)
    let eventEnd = dayjs(event.end)

    return {
      startSelectedIsAfterOrEqualEventStart: startSelected.isAfter(eventStart) || startSelected.isSame(eventStart),
      startSelectedIsAfterEventStart: startSelected.isAfter(eventStart),
      startSelectedIsBeforeEventEnd: startSelected.isBefore(eventEnd),
      startSelectedIsBeforeEventStart: startSelected.isBefore(eventStart),
      startSelectedIsBeforeOrEqualEventStart: startSelected.isBefore(eventStart) || startSelected.isSame(eventStart),
      startSelectedIsBeforeOrEqualEventEnd: startSelected.isBefore(eventEnd) || startSelected.isSame(eventEnd),
      startSelectedIsEqualEventEnd: startSelected.isSame(eventEnd),
      endSelectedIsAfterEventEnd: endSelected.isAfter(eventEnd),
      endSelectedIsAfterEventStart: endSelected.isAfter(eventStart),
      endSelectedIsAfterOrEqualEventStart: endSelected.isAfter(eventStart) || endSelected.isSame(eventStart),
      endSelectedIsBeforeEventStart: endSelected.isBefore(eventStart),
      endSelectedIsEqualEventStart: endSelected.isSame(eventStart),
      startSelected,
      endSelected,
      eventStart,
      eventEnd
    }
  }

  checkIfDateOverlapsAnother = (datesSelected, events) => {
    let overlap = false;
    let same = false;
    let startDate;
    let endDate;
    events.forEach((event) => {
      let datesRelation = this.evauluateDates(datesSelected, event)
      if (datesRelation.startSelected.isSame(datesRelation.eventStart) && datesRelation.endSelected.isSame(datesRelation.eventEnd)) {
        this.handleRemoveDate(event)
        event.remove()
        same = true;
      } else if (
        (datesRelation.startSelectedIsBeforeOrEqualEventStart && datesRelation.endSelectedIsAfterOrEqualEventStart) ||
        (datesRelation.startSelectedIsAfterOrEqualEventStart && datesRelation.startSelectedIsBeforeOrEqualEventEnd)
      ) {
        if (datesRelation.startSelected.isBefore(datesRelation.eventStart)) {
          if (startDate == null || datesRelation.startSelected.isBefore(startDate)) {
            startDate = datesRelation.startSelected
          }
        } else {
          if (startDate == null || datesRelation.eventStart.isBefore(startDate)) {
            startDate = datesRelation.eventStart
          }
        }
        if (datesRelation.endSelected.isAfter(datesRelation.eventEnd)) {
          if (endDate == null || datesRelation.endSelected.isAfter(endDate)) {
            endDate = datesRelation.endSelected
          }
        } else {
          if (endDate == null || datesRelation.eventEnd.isAfter(endDate)) {
            endDate = datesRelation.eventEnd
          }
        }
        this.handleRemoveDate(event);
        event.remove()
        overlap = true;
      }
    });
    if (overlap) {
      this.createBackgroundEvent(startDate.toDate(), endDate.toDate());
    }
    return overlap || same;
  };


  checkIfDatesSelectedBeforeEvent = (datesSelected, events) => {
    let isBefore = false;
    events.forEach((event) => {
      let datesRelation = this.evauluateDates(datesSelected, event)
      if (
        datesRelation.endSelectedIsEqualEventStart || (
          datesRelation.endSelectedIsBeforeEventStart &&
          datesRelation.startSelectedIsBeforeEventStart &&
          datesRelation.endSelectedIsAfterEventStart)
      ) {
        this.createBackgroundEvent(datesSelected.start, event.end);
        this.handleRemoveDate(event);
        event.remove()
        isBefore = true;
      }
    });
    return isBefore;
  };

  checkIfDatesSelectedNextEvent = (datesSelected, events) => {
    let isNext = false;
    events.forEach((event) => {
      let datesRelation = this.evauluateDates(datesSelected, event)
      if (
        datesRelation.startSelectedIsEqualEventEnd || (
          datesRelation.startSelectedIsAfterEventStart &&
          datesRelation.endSelectedIsAfterEventEnd &&
          datesRelation.startSelectedIsBeforeEventEnd)
      ) {
        this.createBackgroundEvent(event.start, datesSelected.end);
        this.handleRemoveDate(event);
        event.remove()
        isNext = true;
      }
    });
    return isNext;
  };

  checkIfDatesInBetweenEvents = (datesSelected, events) => {
    let isInBetween = false;
    let eventBefore = events.filter((event) => {
      return dayjs(event.end).isSame(dayjs(datesSelected.start));
    });
    let eventAfter = events.filter((event) => {

      return dayjs(event.start).isSame(dayjs(datesSelected.end));
    });

    if (eventBefore.length === 1 && eventAfter.length === 1) {
      isInBetween = true;
      this.createBackgroundEvent(eventBefore[0].start, eventAfter[0].end);
      this.handleRemoveDate(eventBefore[0]);
      this.handleRemoveDate(eventAfter[0]);
      eventBefore[0].remove();
      eventAfter[0].remove();
    }

    return isInBetween;
  }

  createBackgroundEvent = (start, end) => {

    let calendarApi = this.calendarRef.current.getApi();
    let id = this.state.eventId + 1;

    this.setState({ eventId: id });

    let event = {
      title: "",
      start: start,
      end: end,
      id: id,
      groupId: "temp",

      background: "rgba(3, 22, 59, 0.9)",//backgroundColor:"rgba(188,232,241,0.95)",
      allDay: true
    };


    calendarApi.addEvent(event);

    this.handleAddDate({ id, start, end });
  }

  handleEventDidMount = (info) => {
    // Apply custom opacity to the event element
    //info.el.style.opacity = '0.5'; // Adjust the value as needed (0.0 to 1.0)
    const computedStyle = getComputedStyle(info.el);
    const backgroundColor = computedStyle.backgroundColor;
    let rgba = backgroundColor.match(/rgba?\((\d+), (\d+), (\d+)(?:, ([\d.]+))?\)/);
    if(rgba) {
      // Extract RGB values and set a new alpha value
      const red = rgba[0];
      const green = rgba[1];
      const blue = rgba[2];


      // Set a new alpha0 value (e.g., 0.5)
      const newAlpha = 1;
      const newBackgroundColor = `rgba(${red}, ${green}, ${blue}, ${newAlpha})`;

      // Apply the new background color
      info.el.style.backgroundColor = newBackgroundColor;
    }

  };

  render() {
    return (
      <div className="demo-app">
        <div className="demo-app-top">&nbsp;</div>
        <div className="demo-app-calendar">
          <CalendarWrapper
            color={"inherit"}
            $headerColor={this.props.isDarkMode ? "white" : "black"}
            opacity={this.props.isDarkMode ? 0.5 : 0.3}
          >
            <FullCalendar
              headerToolbar={{
                left: 'title',
                center: '',
                right: ''
              }}
              initialView="dayGridMonth"
              initialDate={`${this.props.month}-01`}
              eventColor="green"
              height="auto"
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              ref={this.calendarRef}
              events={this.state.events}
              eventClick={this.handleEventClick}
              selectable={true}
              select={this.handleDatesSelected}
              selectOverlap={false}

              dateClick={this.handleDateClick}
              showNonCurrentDates={false}
              
              unselectAuto={true}
              editable={false}
              eventDisplay={'block'}
              eventDidMount={this.handleEventDidMount}
              selectLongPressDelay={200}

            />
          </CalendarWrapper>
          {this.state.showInfo ? (
            <EventInfo
              top={this.state.info.pageY}
              left={this.state.info.pageX}
              color= {this.state.info.color == '' ? 'black' :  this.state.info.color }
              onClick={this.hideToolTip}
            >
              <span className="title">{this.state.info.title}</span>
              {this.state.info.comment ? (
                <span style={{ whiteSpace: 'pre-wrap' }} className="comment">{this.state.info.comment}</span>
              ) : null}
            </EventInfo>
          ) : null}
        </div>
      </div>
    );
  }
}
// background-color: ${(props) => props.color};
const CalendarWrapper = styled.div`
  // background-color: #f8f8f8;

  & th.fc-day-header > span,
  th.fc-day-header,
  .fc-center h2,
  span.fc-day-number {
    color: ${(props) => props.$headerColor} !important;
  }

  & td.fc-bgevent {
    opacity: ${(props) => props.opacity};
  }
  &
    td.fc-event-container
    > a.fc-event:not([style="background-color:rgba(255, 0, 0, 0);border-color:rgba(255, 0, 0, 0);color:black"])
    span.fc-title {
    color: ${(props) => props.color} !important;
  }
`;

const EventInfo = styled.div`
  position: fixed;
  top: ${(props) => props.top + "px"};
  left: ${(props) => props.left + "px"};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border: solid 2px #ccc;
  background-color: #fff;
  border-radius: 5px;
  padding: 0.3rem 0.5rem;
  margin: 0.5rem;
  z-index: 100;
  > .title {
    color: ${(props) => props.color} !important;
  }
  > .comment {
    color: black !important;
  }
`;
